import type { FC } from "react";

import {
    FiltersRowContainer,
    KeywordGeneratorToolPageTableHeaderStyled,
} from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/google-keyword-generator/styledComponents";
import { swSettings } from "app/common/services/swSettings";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { DownloadExcelContainer } from "app/pages/workspace/StyledComponent";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { multiIncludeExcludeType } from "../../../../../../components/multi-include-exclude-filter/consts";
import { MultiIncludeExcludeFilterContainer } from "../../../../../../components/multi-include-exclude-filter/MultiIncludeExcludeFilterContainer";
import type { DynamicFilterRuleForUrl } from "../../../../../../components/multi-include-exclude-filter/types";
import { allTrackers } from "app/services/track/track";

interface IYoutubeKeywordGeneratorTableTopProps {
    totalRecords: number;
    excelDownloadUrl: string;
    excelBodyForReq: DynamicFilterRuleForUrl[];
}

export const YoutubeKeywordGeneratorTableTop: FC<IYoutubeKeywordGeneratorTableTopProps> = ({
    totalRecords,
    excelDownloadUrl,
    excelBodyForReq,
}) => {
    const excelAllowed = swSettings.current.resources.IsExcelAllowed;

    const trackExcelDownload = () => {
        allTrackers.dispatchTrackEvent("Button", "click", "Table/Excel");
    };

    return (
        <KeywordGeneratorToolPageTableHeaderStyled>
            <FiltersRowContainer>
                <MultiIncludeExcludeFilterContainer filterType={multiIncludeExcludeType.KEYWORD} />
            </FiltersRowContainer>
            <FlexRow>
                <DownloadExcelContainer>
                    <DownloadButtonMenu
                        Excel={true}
                        totalCount={totalRecords}
                        downloadUrl={excelDownloadUrl}
                        excelBodyForReq={excelBodyForReq}
                        exportFunction={trackExcelDownload}
                        excelLocked={!excelAllowed}
                    />
                </DownloadExcelContainer>
            </FlexRow>
        </KeywordGeneratorToolPageTableHeaderStyled>
    );
};
